import PropTypes from 'prop-types';
import UserShape from './UserShape';

const ReactionShape = PropTypes.shape({
  author: UserShape,
  emoji: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  thread: PropTypes.object,
});

export default ReactionShape;
